// Home-Szig — all site content (Hungarian). Content preserved from homeszig.hu

export const CONTACT = {
  phone: "+36 70 349 9700",
  phoneHref: "tel:+36703499700",
  email: "homeszig@gmail.com",
  emailHref: "mailto:homeszig@gmail.com",
  hours: "Hétfő – Péntek: 8:00 – 17:00",
};

export const NAV_LINKS = [
  { label: "Szolgáltatások", href: "#szolgaltatasok" },
  { label: "Rólunk", href: "#rolunk" },
  { label: "Előnyök", href: "#elonyok" },
  { label: "Referenciák", href: "#referenciak" },
  { label: "Vélemények", href: "#velemenyek" },
  { label: "Kapcsolat", href: "#kapcsolat" },
];

export const HERO = {
  overline: "Hőszigetelés · 2000 óta",
  titleLines: ["Meleg otthon,", "alacsonyabb rezsi,", "prémium kivitelezés."],
  subtitle:
    "A Home-Szig több mint két évtizede a hőszigetelés szakértője. Korszerű technológiákkal és minőségi alapanyagokkal dolgozunk lakóépületeken, ipari létesítményeken és közintézményeken.",
  primaryCta: "Ingyenes felmérést kérek",
  secondaryCta: "Szolgáltatások megtekintése",
  trust: [
    "20+ év szakmai tapasztalat",
    "Minőségi alapanyagok",
    "Díjmentes helyszíni felmérés",
  ],
  image:
    "https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1920",
};

export const STATS = [
  { value: 20, suffix: "+", label: "Év szakmai tapasztalat" },
  { value: 100, suffix: "%", label: "Korszerű technológiák" },
  { value: 500, suffix: "+", label: "Elvégzett projekt" },
  { value: 30, suffix: "–50%", label: "Elérhető energiamegtakarítás", raw: true },
];

export const ABOUT = {
  overline: "Rólunk",
  title: "Tapasztalat, amelyre otthona építhet",
  paragraphs: [
    "Üdvözöljük a Home-Szig oldalán. Cégünk a 2000-es évek eleje óta a hőszigetelésben tevékenykedik az energiatakarékosság és környezetvédelem szolgálatában.",
    "Tapasztalt csapataink a legmodernebb technológiákat és anyagokat alkalmazzák, hogy biztosítsák az optimális hőszigetelést — legyen szó lakóépületekről, ipari létesítményekről vagy közintézményekről.",
  ],
  bullets: [
    "Több évtizedes szakmai háttér",
    "Gyártói rendszerek garanciájával",
    "Precíz, határidőre kész kivitelezés",
  ],
  images: [
    "/images/workers.webp",
    "/images/floor.jpg",
  ],
};

export const SERVICES = [
  {
    id: "homlokzati",
    number: "01",
    title: "Homlokzati hőszigetelés",
    description:
      "Komplett homlokzati hőszigetelő rendszerek kivitelezése, amely csökkenti a hőveszteséget és megújítja épülete külső megjelenését.",
    image: "/images/facade.jpg",
    href: "https://www.homeszig.hu/homlokzati-hoszigeteles",
  },
  {
    id: "tetoter",
    number: "02",
    title: "Tetőtér-szigetelés",
    description:
      "Hatékony tetőtéri hőszigetelés, amely nyáron a felmelegedés, télen a hőveszteség ellen véd, kellemes belső klímát biztosítva.",
    image: "/images/eps.webp",
    href: "https://www.homeszig.hu/tetoter-szigeteles",
  },
  {
    id: "padlo",
    number: "03",
    title: "Padló- és födémszigetelés",
    description:
      "Padló- és födémszigetelési megoldások a hidegpadlók és a lefelé irányuló hőveszteség megszüntetésére, magasabb komfortért.",
    image: "/images/house3d.jpg",
    href: "https://www.homeszig.hu/padlo-es-fodemszigeteles",
  },
];

export const BENEFITS = [
  {
    icon: "PiggyBank",
    title: "Energiatakarékosság",
    description:
      "Csökkentse fűtési és hűtési költségeit hatékony hőszigetelési megoldásainkkal.",
  },
  {
    icon: "ThermometerSun",
    title: "Kényelem",
    description:
      "Optimális belső hőmérséklet télen és nyáron egyaránt — otthona mindig kellemes marad.",
  },
  {
    icon: "HeartPulse",
    title: "Egészség",
    description:
      "Csökkenti a nedvességet és a penészesedés kockázatát, így otthona egészségesebb lesz.",
  },
  {
    icon: "TrendingUp",
    title: "Értéknövelés",
    description:
      "A minőségi hőszigetelés növeli ingatlana értékét — befektetés, amely hosszú távon megtérül.",
  },
];

export const PROCESS = [
  { number: "01", title: "Kapcsolatfelvétel", description: "Vegye fel velünk a kapcsolatot telefonon vagy az űrlapon keresztül." },
  { number: "02", title: "Díjmentes felmérés", description: "Szakértőnk helyszíni felmérést végez, teljesen díjmentesen." },
  { number: "03", title: "Személyre szabott ajánlat", description: "Igényeire szabott, átlátható árajánlatot készítünk." },
  { number: "04", title: "Kivitelezés", description: "Precíz, minőségi kivitelezés minőségi alapanyagokból." },
  { number: "05", title: "Átadás", description: "Az elkészült munkát átadjuk, garanciával a nyugalmáért." },
];

export const REFERENCES = [
  { url: "/references/ref1.png", title: "Elkészült homlokzati hőszigetelés", span: "tall" },
  { url: "/references/ref2.webp", title: "Homlokzat felújítás – előtte és utána", span: "wide" },
  { url: "/references/portfolio_1.webp", title: "Új építésű ház hőszigetelése", span: "" },
  { url: "/references/portfolio_4.webp", title: "Modern ház homlokzati szigetelése", span: "" },
  { url: "/references/ref5.webp", title: "Kész homlokzat és lábazat", span: "wide" },
  { url: "/references/portfolio_2.webp", title: "Homlokzati rendszer építés közben", span: "tall" },
  { url: "/references/portfolio_3.webp", title: "Családi ház homlokzati szigetelése", span: "" },
];

export const TESTIMONIALS = [
  {
    name: "Andrea",
    rating: 5,
    text: "A homlokzati hőszigetelés után a házunk teljesen megújult! Nem csak az energiafogyasztás csökkent jelentősen, de a ház értéke is nőtt. A csapat professzionális volt, és a munka minősége kivételes.",
  },
  {
    name: "László",
    rating: 5,
    text: "A tetőtér szigetelése tökéletes lett! Nyáron végre nem melegszik fel annyira a lakás, és télen is sokkal kevesebbet kell fűteni. A munkát gyorsan és precízen végezték el.",
  },
  {
    name: "Éva",
    rating: 5,
    text: "A homlokzati hőszigetelés nem csak energiatakarékosabbá tette a házat, de sokkal szebb is lett. A színválasztásban is segítettek, remek ötleteik voltak.",
  },
];

export const PARTNERS = [
  { name: "Baumit", logo: "https://www.homeszig.hu/assets/site/img/baumit.png" },
  { name: "Austrotherm", logo: "https://www.homeszig.hu/assets/site/img/austrotherm.png" },
  { name: "Layher", logo: "https://www.homeszig.hu/assets/site/img/layher.png" },
];

export const CTA_BLOCK = {
  title: "Tudja meg, milyen hőszigetelési megoldás lenne ideális otthonához!",
  subtitle:
    "Kérjen díjmentes, kötelezettség nélküli helyszíni felmérést. Szakértőink személyre szabott javaslatot készítenek Önnek.",
  primaryCta: "Díjmentes felmérést kérek",
};

export const SURVEY_QUESTIONS = [
  {
    id: "propertyType",
    number: "01",
    label: "Ingatlan típusa",
    options: ["Családi ház", "Ikerház", "Sorház", "Egyéb"],
    cols: "sm:grid-cols-4",
  },
  {
    id: "propertySize",
    number: "02",
    label: "Az ingatlan mérete (kb.)",
    options: ["80 m² alatt", "80–120 m²", "120–160 m²", "160 m² felett"],
    cols: "sm:grid-cols-4",
  },
  {
    id: "currentState",
    number: "03",
    label: "Jelenlegi állapot",
    options: [
      "Még nincs semmilyen hőszigetelés",
      "Van, de elavult/hibás",
      "Nem tudom biztosan",
    ],
    cols: "sm:grid-cols-3",
  },
  {
    id: "timeline",
    number: "04",
    label: "Mikorra tervezné a kivitelezést?",
    options: [
      "Minél hamarabb (1 hónapon belül)",
      "1–2 hónapon belül",
      "Még csak tájékozódom",
    ],
    cols: "sm:grid-cols-3",
  },
];
